import React from 'react'
import { graphql } from 'gatsby'
import './MobileLead.scss'
import mobil from '../../assets/svg/mobil.svg'

export default function MobileLead({text, title}) {
	return(
		<div className="MobileLead">
			<div className="content">
				{title && <h1>{title}</h1>}
				{text && <p className="lead">{text}</p>}
			</div>
			<div className="image">
				<img src={mobil} alt="mobil" />
			</div>
		</div>
	)
}

export const query = graphql`
	fragment MobileLead on WpPage_Layout_block_Layout_MobileLead {
		fieldGroupName
		text
		title
	}
`;